module.exports = __webpack_public_path__ + "static/media/ic_freeehand_inverted.8a656573.svg";